import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { ThemeModeProvider } from './theme';

const normalizeBasePath = (value?: string | null): string => {
  if (!value || value === '/' || value === './') {
    return '';
  }
  const trimmed = value.replace(/^\/+|\/+$/g, '');
  return trimmed ? `/${trimmed}` : '';
};

const normalizedRouterBase = normalizeBasePath(import.meta.env.BASE_URL as string | undefined);
const routerBasename =
  normalizedRouterBase && typeof window !== 'undefined'
    ? window.location.pathname.startsWith(normalizedRouterBase)
      ? normalizedRouterBase
      : undefined
    : normalizedRouterBase || undefined;

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ThemeModeProvider>
        <CssBaseline />
        <BrowserRouter basename={routerBasename}>
          <App />
        </BrowserRouter>
      </ThemeModeProvider>
    </Provider>
  </QueryClientProvider>,
);
